export default {
  template: {
    title: 'Candidate Questionnaire Management',
    menu: 'Candidate Questionnaire Management',
    taskTitle: 'Question Update Task Management'
  },
  label: {
    group: 'Template',
    groupName: 'Template Name',
    questionType: 'Question Type',
    questionTitle: 'Title',
    includeKnockoutOptions: 'Include knockout options',
    createUpdateTask: 'Create update task',
    options: 'Options',
    allOptions: 'All Options',
    markAsKnockoutOptions: 'Mark as knockout option',
    unGrouped: 'Not in Template',
    duration: 'Duration',
    visibility: 'Visibility',
    templateName: 'Template Name',
    updateJobs: 'Updated Jobs',
    executeTime: 'Estimated Start Time',
    executeStatus: 'Status',
    finishTime: 'Finished Time',
    noJobs: 'None',
    taskStatus: {
      pending: 'Pending',
      executing: 'Executing',
      success: 'Success',
      failure: 'Failure'
    },
    status: 'Status',
    otherGroup: '———————— Not in Template ———————'
  },
  editor: {
    group: {
      title: {
        add: 'Add Template',
        edit: 'Edit Template'
      }
    },
    question: {
      title: {
        add: 'Add Question',
        edit: 'Edit Question'
      }
    }
  },
  questionType: {
    TEXT: 'Text Question',
    SELECT: 'Single-select Question',
    CHECKBOX: 'Multi-select Question',
    VIDEO: 'Video Question',
    ATTACHMENT: 'Attachment Question',
    SINGLE_SELECT: 'Dropdown List Question - Single-select',
    MULTIPLE_SELECT: ' Dropdown List Question - Multi-select',
    DATE: 'Date Format Question'
  },
  btn: {
    addGroup: 'Add New Template',
    addQuestion: 'Add New Question',
    addNewGroup: 'Add New Template',
    addNewQuestion: 'Add New Question',
    moveQuestion: 'Move to',
    addQuestionFromTemplate: 'Add From Question Template',
    taskList: 'Task List',
    back: 'Back',
    questionOptions: {
      expand: 'Show Options',
      collapse: 'Hidden Options'
    }
  },
  placeholder: {
    questionTypeFilter: 'Select Type',
    groupFilter: 'Select Template',
    groupQuestionKeywordsFilter: 'Search question by title',
    options: 'Option 1\nOption 2\nOption 3\n...etc',
    markAsKnockoutOptions: 'Choice knockout options'
  },
  message: {
    notKnockoutOptionsTip: 'Input your response options, or paste from Excel.',
    knockoutOptionsTip: 'When the candidate answer with the "Options", their application will appear in the application list as normal. When the candidate answers with the "Knockout Options" their application will appear in the "Disqualified" status folder.',
    executeTime: 'It will be finished within around 10 minutes after start.',
    duplicateTitle: 'Oops, seems there are duplicated questions, please update and resubmit.',
    confirmEnable: {
      disable: 'Confirm to disable?',
      enable: 'Confirm to enable?'
    }
  },
  visibilityType: {
    IE: 'Internal & External',
    I: 'Internal Only',
    E: 'External Only'
  }
}
